const transaction = {
  TRANSACTION_DATA_FETCH: 'TRANSACTION_DATA_FETCH',
  TRANSACTION_DATA_SUCCESS: 'TRANSACTION_DATA_SUCCESS',
  TRANSACTION_DATA_ERROR: 'TRANSACTION_DATA_ERROR',
};

export default transaction;
